var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form-group", class: _vm.classObject },
    [
      _vm.mode === "show"
        ? [
            (_vm.displayLabel === true && _vm.getShowRouteName() == null) ||
            _vm.getShowId() == null
              ? _c("label", { staticClass: "control-label col-md-3" }, [
                  _vm._v("\n            " + _vm._s(_vm.title) + "\n        ")
                ])
              : _vm.displayLabel === true
              ? _c("label", { staticClass: "control-label col-md-3" }, [
                  _c(
                    "a",
                    { attrs: { href: _vm.generateRoute(), target: "_blank" } },
                    [
                      _vm._v(_vm._s(_vm.title) + " "),
                      _c("i", { staticClass: "fa fa-link" })
                    ]
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { class: _vm.inputClass }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.val,
                    expression: "val"
                  }
                ],
                staticClass: "form-control",
                attrs: {
                  id: _vm.id,
                  lang: "pl-PL",
                  disabled: _vm.disabled,
                  type: "text"
                },
                domProps: { value: _vm.val },
                on: {
                  keypress: _vm.isNumber,
                  change: function($event) {
                    return _vm.$emit("change", $event)
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.val = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _vm.allowSingleEdit === true
                ? _c(
                    "span",
                    {
                      staticClass: "fast-edit-button",
                      on: {
                        click: function($event) {
                          _vm.mode = "edit"
                        }
                      }
                    },
                    [_c("i", { staticClass: "fa fa-pencil-square" })]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.errorText
                ? _c("span", { staticClass: "help-block" }, [
                    _c("p", [_vm._v(" " + _vm._s(_vm.errorText) + " ")])
                  ])
                : _vm._e()
            ])
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.mode === "edit"
        ? [
            (_vm.displayLabel === true && _vm.getShowRouteName() == null) ||
            _vm.getShowId() == null
              ? _c("label", { staticClass: "control-label col-md-3" }, [
                  _vm._v("\n          " + _vm._s(_vm.title) + "\n        ")
                ])
              : _vm.displayLabel === true
              ? _c("label", { staticClass: "control-label col-md-3" }, [
                  _c(
                    "a",
                    { attrs: { href: _vm.generateRoute(), target: "_blank" } },
                    [
                      _vm._v(_vm._s(_vm.title) + " "),
                      _c("i", { staticClass: "fa fa-link" })
                    ]
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { class: _vm.inputClass },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.editValue,
                      expression: "editValue"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { id: _vm.id, lang: "pl-PL", type: "text" },
                  domProps: { value: _vm.editValue },
                  on: {
                    keypress: _vm.isNumber,
                    change: function($event) {
                      return _vm.$emit("change", $event)
                    },
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.editValue = $event.target.value
                    }
                  }
                }),
                _vm._v(" "),
                _vm.processEdit === true
                  ? [_vm._m(0)]
                  : [
                      _vm.allowSingleEdit === true
                        ? _c(
                            "span",
                            {
                              staticClass: "fast-save-button",
                              on: {
                                click: function($event) {
                                  return _vm.saveEdit()
                                }
                              }
                            },
                            [_c("i", { staticClass: "fa fa-save" })]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.allowSingleEdit === true
                        ? _c(
                            "span",
                            {
                              staticClass: "fast-cancel-button",
                              on: {
                                click: function($event) {
                                  _vm.editValue = _vm.val
                                  _vm.mode = "show"
                                }
                              }
                            },
                            [_c("i", { staticClass: "fa fa-ban" })]
                          )
                        : _vm._e()
                    ],
                _vm._v(" "),
                _vm.errorText
                  ? _c("span", { staticClass: "help-block" }, [
                      _c("p", [_vm._v(" " + _vm._s(_vm.errorText) + " ")])
                    ])
                  : _vm._e()
              ],
              2
            )
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "fast-save-process" }, [
      _c("i", { staticClass: "fa fa-spin fa-spinner" })
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-243f5daa", { render: render, staticRenderFns: staticRenderFns })
  }
}